import { IntlShape } from "react-intl";

export const getSummaryTooltip = (
	intl: IntlShape,
	isFeatureUnavailable: boolean,
	canGenerateSummary = false
): string => {
	if (isFeatureUnavailable) {
		return intl.formatMessage({ id: "Interaction.Buttons.FeatureNotAvailable" });
	}
	return canGenerateSummary
		? intl.formatMessage({ id: "Summary.Show" })
		: intl.formatMessage({ id: "Summary.SubscriptionRequired" });
};